import React from "react";
import {withTranslation} from "react-i18next";
import DrawingResult from "../DrawingResultV2";
import {useLotto5d} from "../../../store/lotto5d/Lotto5dContext";
import BettingMobile from "../../betting/mobile/BettingMobile";
import TabView from "../../lotto/TabView";
import RecentTicket from "../RecentTicket";
import HistoryResultMobile from "./HistoryResultMobile";


function Sale(props) {
    const lotto = useLotto5d();
    const {t} = props;

    const {config: {lotto90PackagePrices}} = lotto;

    const bettingProps = {
        ...lotto,
        PackagePrices: lotto90PackagePrices
    }

    const tabs = [
        t("labels:drawing.betting"),
        t("labels:drawing.result")
    ];
    const children = [
        <RecentTicket isMobile/>,
        <HistoryResultMobile {...lotto}/>
    ]


    return (
        <div id="lo5d-mobile">
            <div className="betting-board lo5d lo5d-v1">
                <div className="m-0">
                    <div className="d-flex justify-content-between w-100">
                        <div className="lo5d-mid-side">
                            <DrawingResult isMobile/>
                            <BettingMobile {...bettingProps}/>
                            <div className="tab-view border-all">
                                <TabView children={children} tabs={tabs}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default withTranslation()(Sale);

